import React from "react";
import { companyInfo } from "../mock";
import { Phone, Mail, MapPin, Instagram, Facebook, Twitter } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[color:var(--brand-teal-dark)] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img
              src="https://customer-assets-0z36b82j.emergentagent.net/job_relocate-easy-18/artifacts/7yo2uqgh_Black%20and%20White%20Simple%20Letter%20B%20Logo.png"
              alt="ERM logo"
              data-testid="footer-logo"
              className="w-12 h-12 rounded-full bg-white object-contain"
            />
            <div className="font-display font-bold text-xl">ERM RELOCATIONS</div>
          </div>
          <p className="text-white/70 mt-4 leading-relaxed text-sm">
            Reliable and secure relocation, storage, and cargo services across the UAE and worldwide.
          </p>
        </div>

        <div>
          <h4 className="font-display font-bold text-lg mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm text-white/75">
            <li><a href="#home" className="hover:text-[color:var(--brand-red)] transition-colors">Home</a></li>
            <li><a href="#about" className="hover:text-[color:var(--brand-red)] transition-colors">About</a></li>
            <li><a href="#services" className="hover:text-[color:var(--brand-red)] transition-colors">Services</a></li>
            <li><a href="#contact" className="hover:text-[color:var(--brand-red)] transition-colors">Contact</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-lg mb-4">Services</h4>
          <ul className="space-y-2 text-sm text-white/75">
            <li>International Sea Cargo</li>
            <li>International Air Cargo</li>
            <li>Door-to-Door Relocation</li>
            <li>Storage Solutions</li>
            <li>Customs Clearance</li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-lg mb-4">Get in Touch</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-center gap-2"><Phone size={14} /> {companyInfo.phone}</li>
            <li className="flex items-center gap-2"><Mail size={14} /> {companyInfo.email}</li>
            <li className="flex items-center gap-2"><MapPin size={14} /> {companyInfo.address}</li>
          </ul>
          <div className="flex gap-3 mt-4">
            <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[color:var(--brand-red)] flex items-center justify-center transition-colors"><Instagram size={16} /></a>
            <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[color:var(--brand-red)] flex items-center justify-center transition-colors"><Facebook size={16} /></a>
            <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[color:var(--brand-red)] flex items-center justify-center transition-colors"><Twitter size={16} /></a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-white/60">
        <div>&copy; {new Date().getFullYear()} ERM Relocations L.L.C. All rights reserved.</div>
        <div>ermrelocations.com</div>
      </div>
    </footer>
  );
};

export default Footer;
